import React from "react";
import { connect } from "react-redux";
import Login from "@features/auth/components/Login/Login";
import { useIsAuthenticated } from "@azure/msal-react";

const Protected = (props) => {
  const Component = props?.component;
  // eslint-disable-next-line no-unused-vars
  const msalAuthenticated = useIsAuthenticated();
  const reduxAuthenticated = props?.isAuthenticated;
  const isAuthenticated = reduxAuthenticated;

  // null = auth state not yet determined (persist rehydrating)
  // Treat as unauthenticated so login page is shown and no protected APIs fire
  if (isAuthenticated === null) return <Login />;

  // null = auth state not yet determined (persist rehydrating)
  // Treat as unauthenticated so login page is shown and no protected APIs fire
  if (isAuthenticated === null) return <Login />;

  return <div>{isAuthenticated ? <Component /> : <Login />}</div>;
};

const mapStateToProps = (state) => ({
  isAuthenticated: state?.tokens?.isAuthenticated,
});

export default connect(mapStateToProps)(Protected);
